import { OpenAPIV3 } from 'openapi-types';

import {
  DereferencedOperationObject,
  DereferencedPathItemObject,
  methods,
} from '@/pages/api-documentation/constants/types';
import Item, {
  ItemSecurity,
} from '@/pages/api-documentation/sections/reference/components/ReferenceView/components/Item';

interface Props {
  path: string;
  pathItem: DereferencedPathItemObject;
  tagName: string | null;
  compact: boolean;
  security: ItemSecurity;
  servers: OpenAPIV3.ServerObject[] | undefined;
}

/**
 * @param tagName If provided, only operations with this tag will be rendered.
 *                If null, only operations without any tags will be rendered.
 */
export function PathItem({ path, pathItem, tagName, compact, security, servers }: Props) {
  return methods
    .map((httpMethod) => {
      const operationObject = pathItem[httpMethod];

      if (!shouldRenderOperation(operationObject, tagName)) return null;

      return (
        <Item
          compact={compact}
          key={`${httpMethod}-${path}`}
          operation={httpMethod}
          operationObject={operationObject}
          parameters={pathItem.parameters}
          path={path}
          security={security}
          servers={pathItem.servers ?? servers}
        />
      );
    })
    .filter(Boolean);
}

function shouldRenderOperation(
  operationObject: DereferencedOperationObject | undefined,
  tagName: string | null,
): operationObject is DereferencedOperationObject {
  if (!operationObject) return false;

  // Filter out operations that do not match the specified tag if tagName is provided
  if (tagName && operationObject.tags?.[0] !== tagName) return false;

  // Filter out operations that have a tag if tagName is null (no tag)
  if (tagName === null && operationObject.tags && operationObject.tags.length > 0) return false;

  return true;
}
